// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"166":"8dc21398","186":"806072b4","187":"395977d3","400":"1cb2473d","798":"c8e6bd22","804":"f42fceeb","830":"fd202690"}[chunkId] + ".js";
};